//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength, maxLength, helpers } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import errorTags from "@/ErrorTags";
import addMatchNumber from "@/components/matchNumber/addMatchNumber.vue";
import editMatchNumber from "@/components/matchNumber/editMatchNumber.vue";
import deleteMatchNumber from "@/components/matchNumber/deleteMatchNumber.vue";
import moment from 'moment'
import { date } from 'quasar'

const containDate = helpers.regex("containAlphaNum", /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);

export default {
  components: {
    ValidateResult,
    addMatchNumber,
    editMatchNumber,
    deleteMatchNumber
  },
  data () {
    return {
      dpMatchDate: new Date().toISOString().slice(0,10),
      dtMatchDate: null,
      // txtFilterDataTableList: "",

      strTableSeparators: 'cell',
      blnDense: true,
      blnLoading: false,
      blnMatchDateAutoFocus: true,

      strMaskTextBox:'####-##-##',
      strMaskDatePicker: "YYYY-MM-DD",

      aryData: [],
      aryAPIData: [],
      aryVisibleColumns: [ 'match_date', 'red_num', 'pool', 'created_on', 'updated_on', 'updated_by', 'action' ],
      aryColumns: [
        { name: 'match_date', label: 'Match Date', field: '', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'red_num', label: 'Number', field: 'red_num', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'pool', label: 'Pool', field: 'pool', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'created_on', label: 'Created On', field: 'created_on', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'updated_on', label: 'Updated On', field: 'updated_on', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'updated_by', label: 'Updated By', field: 'updated_by', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'action', label: 'action', field: '', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
      ],
      strRowKey: "red_num",

      dicPagination: {
        sortBy: 'red_num',
        descending: false,
        page: 1,
        rowsPerPage: config.aryPageSizeList[0],
        rowsNumber: 0
      },

      aryOptionsPageSizeList: config.aryPageSizeList,

      blnShowMessage: false,
      strBannerClass: "",
      strBannerMessage: "",

      blnDialogAdd: false,
      blnDialogEdit: false,
      blnDialogDelete: false,

      dataMatchDate: "",
      dataRedNumber: "",
      dataPool: "",

      jsonResponse: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    dpMatchDate: {
      required,
      containDate,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
  },
  mounted: function() {
    this.aryData = [];
    this.dicPagination.page = 1;

    this.fcGetDataList();
  },
  methods: {
    fcValidationDate (strValue) {
      return date.isValid(strValue) || "Invalid Date.";
    },
    fcMatchDateAutoClose () {
      this.$refs.puDatePicker.hide();
    },
    fcSearch () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.aryData = [];
        this.dicPagination.page = 1;

        this.fcGetDataList();
      }
    },
    fcGetDataList () {
      let apiURL = config.matchNumberList_Url();

      var jsonRequest = {
        session_token: this.$store.getters.sessionToken,
        user_id: this.$store.getters.username,
        match_date: this.dpMatchDate,
        page_number: this.dicPagination.page,
        page_size: this.dicPagination.rowsPerPage,
      };

      // console.log(jsonRequest);

      this.blnLoading = true;
      this.jsonResponse.success = true;

      this.$http.post(apiURL, jsonRequest).then(
        function(apiResponse) {
          // Json Response Success
          // console.log(apiResponse);
          this.blnLoading = false;

          try {
            if (apiResponse) {
              if (typeof apiResponse.data.status == "string") {
                this.jsonResponse.success = apiResponse.data.status == "1";
              } else {
                this.jsonResponse.success = apiResponse.data.status == 1;
              }

              this.jsonResponse.status = apiResponse.data.statusdesc;

              if (this.jsonResponse.success == true) {
                this.aryAPIData  = apiResponse.data.value;
                if (this.aryAPIData.length > 0) {
                  this.aryData = this.aryAPIData;
                }

                this.dtMatchDate = this.dpMatchDate;
                this.dicPagination.rowsNumber = apiResponse.data.value[0]["totalrows"];
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                this.blnShowMessage = true;
                this.strBannerClass = "cssBannerError";
                this.strBannerMessage = this.jsonResponse.status;

                if (this.jsonResponse.status == "invalidToken"){
                  this.$helpers.handleFeedback(this.jsonResponse.status);
                }
              }
            }
          } catch (error) {
            this.jsonResponse.success = false;
            this.jsonResponse.status = errorTags.request.failed;
          }
        },
        function(apiResponse) {
          // Json Response Error
          this.blnLoading = false;
          this.jsonResponse.success = false;
          this.jsonResponse.status = errorTags.request.failed;
        }
      )
    },
    fcRequest (props) {
      const { page, rowsPerPage, rowsNumber } = props.pagination;

      this.blnLoading = true;

      this.dicPagination.page = page;

      if (rowsPerPage === 0) {
        this.dicPagination.rowsPerPage = rowsNumber;
      }else{
        this.dicPagination.rowsPerPage = rowsPerPage;
      }

      this.blnLoading = false;

      this.fcGetDataList();
    },
    fcFormatDateTime (strValue) {
      // YYYY-MM-DD hh:mm:ss.SSS a
      return moment(new Date(strValue)).format('YYYY-MM-DD hh:mm:ss a');
    },
    fcAdd() {
      this.blnDialogAdd = true;
    },
    fcSuccessAdd: function(dtMatchDate, intRedNumber, decPool, blnBox) {
      // this.blnDialogAdd = false;

      if (this.dtMatchDate != dtMatchDate){
        return;
      }

      let newItem = {
        red_num: intRedNumber,
        pool: decPool,
        created_on: moment(new Date()).format('YYYY-MM-DD hh:mm:ss a'),
        updated_on: moment(new Date()).format('YYYY-MM-DD hh:mm:ss a'),
        updated_by: this.$store.getters.username
      };

      this.aryData.unshift(newItem);
    },
    fcCancelAdd: function() {
      this.blnDialogAdd = false;
    },
    fcEdit (dataRow) {
      this.blnDialogEdit = true;

      this.dataMatchDate = this.dtMatchDate;
      this.dataRedNumber = dataRow.red_num;
      this.dataPool = dataRow.pool;
    },
    fcSuccessEdit: function(dtMatchDate, intRedNumber, decPool) {
      this.blnDialogEdit = false;

      let gloThis = this;
      this.aryData.filter(function(tblInfo) {
        if (tblInfo.red_num == intRedNumber) {
          tblInfo.pool = decPool;
          tblInfo.updated_on = moment(new Date()).format('YYYY-MM-DD hh:mm:ss a');
          tblInfo.updated_by = gloThis.$store.getters.username;
        }
      });

      this.$helpers.showDialog(this.$t("ui.combine.edit_match_number"), this.$t("message.success"), "success");
    },
    fcCancelEdit: function() {
      this.blnDialogEdit = false;
    },
    fcDelete (dataRow) {
      this.blnDialogDelete = true;

      this.dataMatchDate = this.dtMatchDate;
      this.dataRedNumber = dataRow.red_num;
      this.dataPool = dataRow.pool;
    },
    fcSuccessDelete: function(dtMatchDate, intRedNumber, decPool) {
      this.blnDialogDelete = false;

      let intIndex = this.aryData.map(tblInfo => {return tblInfo.red_num}).indexOf(intRedNumber);
      this.aryData.splice(intIndex, 1);

      this.$helpers.showDialog(this.$t("ui.combine.delete_match_number"), this.$t("message.success"), "success");
    },
    fcCancelDelete: function() {
      this.blnDialogDelete = false;
    },
    fcHandleFail: function(tag, status) {
      // this.blnDialogAdd = false;
      // this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
  }
};
